<template>
  <header class="row-me center-all" :class="{'mobile-mode': isMobile, 'header-scrolled': isMobile && isScrolled}">
    <div class="header-content h100Per row-me center-all">
      <!-- Logo -->
      <div class="logo-wrapper pointer" @click="clickTab({path: '/home'})">
        <img src="../assets/img/logo.png" class="img-logo-w" draggable="false" v-if="isWhite">
        <img src="../assets/img/logo.png" class="img-logo" draggable="false" v-if="isMobile&&!isWhite">
        <img src="../assets/img/logo.png" class="img-logo" draggable="false" v-if="!isMobile&&!isWhite">
      </div>

      <!-- PC端导航菜单 -->
      <div class="flex1 overflow-auto row-me flex-sb pc-nav mT10" v-if="!isMobile">
        <template v-for="(item,index) in navArray" :key="index">
          <!-- 导航项 -->
          <el-dropdown v-if="item.children && item.children.length > 0" popper-class="custom-dropdown" trigger="hover"
                       @command="handleSubMenu">
            <div class="nav-item" :class="{'nav-item-active':tabIndex===item.path}" @click="clickNavWithChildren(item)">
              <span class="colorBlue alignC">{{ item.title }}</span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(child,cIndex) in item.children" :key="cIndex" :command="child.path"
                                  :class="{'sub-menu-active': isSubMenuActive(child.path)}">
                  <span class="font-m">{{ child.title }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <div v-else class="nav-item"
               :class="{'nav-item-active':tabIndex===item.path,'w60 alignJ':item.title==='首页'}"
               @click="clickTab(item)">
            <span class="colorBlue alignC">{{ item.title }}</span>
          </div>
          <!-- 分隔符 -->
          <div class="nav-separator">|</div>
        </template>
      </div>

      <!-- 移动端右侧区域 -->
      <div class="mobile-right" v-if="isMobile">
        <!-- 语言切换 -->
        <el-dropdown trigger="click" @command="menuClick" popper-class="custom-dropdown-mobile">
          <div class="row-me row-center pointer language-btn">
            <img src="../assets/img/home/组%209.png" class="img18 mR5 objScaleDown" draggable="false">
            <div class="font14 language-text font-n" :class="{'colorWhite':isWhite}">{{ nowLanguage }}</div>
            <img src="../assets/img/home/xia.png" class="img12 objContain mL5" draggable="false">
          </div>
          <template #dropdown>
            <el-dropdown-menu class="mobile-menu">
              <el-dropdown-item v-for="lang in supportedLocales" :key="lang.code" :command="lang.code">
                {{ lang.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <!-- 菜单按钮 -->
        <div class="menu-btn" @click="toggleMobileMenu">
          <div class="menu-icon" :class="{'menu-icon-active': mobileMenuVisible}">
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <!-- PC端语言切换 -->
      <div class="language-switch mL25" v-if="!isMobile">
        <el-dropdown @command="menuClick" popper-class="custom-dropdown">
          <div class="row-me row-center pointer language-btn">
            <img src="../assets/img/home/组%209.png" class="img18 mR5 objScaleDown" draggable="false">
            <div class="font16 language-text">{{ nowLanguage }}</div>
            <img src="../assets/img/home/xia.png" class="img12 objScaleDown mL5" draggable="false">
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-for="lang in supportedLocales" :key="lang.code" :command="lang.code">
                {{ lang.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <!-- 移动端菜单弹出层 -->
    <transition name="mobile-menu-slide">
      <div class="mobile-menu-overlay" v-if="isMobile && mobileMenuVisible" @click="closeMobileMenu">
        <div class="mobile-menu-panel" @click.stop>
          <div class="mobile-menu-list">
            <template v-for="(item, index) in navArray" :key="index">
              <!-- 一级菜单 -->
              <div class="mobile-menu-item" :class="{'mobile-menu-item-active': tabIndex === item.path}">
                <div class="mobile-menu-title" @click="handleMobileNavClick(item)">
                  <span>{{ item.title }}</span>
                  <span class="mobile-menu-arrow" v-if="item.children && item.children.length > 0">▼</span>
                </div>
                <!-- 二级菜单 - 始终展开 -->
                <div class="mobile-sub-menu" v-if="item.children && item.children.length > 0">
                  <div class="mobile-sub-item"
                       v-for="(child, cIndex) in item.children"
                       :key="cIndex"
                       :class="{'mobile-sub-item-active': isSubMenuActive(child.path)}"
                       @click="handleMobileSubMenuClick(child.path)">
                    {{ child.title }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import {ArrowDownBold} from "@element-plus/icons";
import {deviceState} from "@/utils/device";
import {getCurrentLanguageName, setLanguage, supportedLocales} from "@/i18n";
import {getArticleCategories, getProductCategories} from "@/http/api";
import bus from "@/assets/js/bus";

export default {
  components: {
    ArrowDownBold
  },
  props: {},
  data() {
    return {
      tabIndex: '/home',
      subMenuPath: '', // 当前选中的二级菜单路径
      // 移动端相关
      deviceState, // 引用全局设备状态
      supportedLocales, // 支持的语言列表
      mobileMenuVisible: false,
      expandedMenu: '', // 当前展开的一级菜单
      isWhite: false,//白色字体
      isScrolled: false, // 页面是否滚动超过1000px
      scrollContainer: null, // 滚动容器元素
      // API分类数据
      productCategories: [], // 产品分类
      academicCategories: [], // 学术资讯分类
      newsCategories: [], // 企业动态分类
    }
  },
  computed: {
    // 从全局状态获取是否为移动端
    isMobile() {
      return this.deviceState.isMobile
    },
    // 当前语言显示文本
    nowLanguage() {
      return getCurrentLanguageName()
    },
    // 导航数组 - 使用计算属性以支持动态语言切换和API数据
    navArray() {
      // 产品分类子菜单 - 从API获取
      const productChildren = this.productCategories.map((item, index) => ({
        title: item.name,
        path: `/products?tab=${index}`
      }))
      // 学术资讯分类子菜单 - 从API获取
      const academicChildren = this.academicCategories.map((item) => ({
        title: item.name,
        path: `/academic?categoryId=${item.id}`
      }))
      // 企业动态分类子菜单 - 从API获取
      const newsChildren = this.newsCategories.map((item) => ({
        title: item.name,
        path: `/news?categoryId=${item.id}`
      }))

      return [{
        title: this.$t('nav.home'),
        path: '/home',
      }, {
        title: this.$t('nav.aboutUs'),
        path: '/aboutUs',
        children: [{
          title: this.$t('nav.companyIntro'),
          path: '/aboutUs'
        }, {
          title: this.$t('nav.awardsHonors'),
          path: '/prize'
        }]
      }, {
        title: this.$t('nav.products'),
        path: '/products',
        children: productChildren
      }, {
        title: this.$t('nav.academic'),
        path: '/academic',
        children: academicChildren
      }, {
        title: this.$t('nav.news'),
        path: '/news',
        children: newsChildren
      }, {
        title: this.$t('nav.contactUs'),
        path: '/contact',
      }]
    }
  },
  created() {
    let path = this.$route.path
    this.dealNav(path)
    // 加载分类数据
    this.loadCategories()
    // 监听语言切换事件，重新加载分类数据
    bus.$on('language-changed', this.onLanguageChanged)
  },
  mounted() {
    if (!this.isMobile) {
      return
    }
    // 添加滚动监听 - 监听 #content 容器
    this.$nextTick(() => {
      this.scrollContainer = document.getElementById('content')
      if (this.scrollContainer) {
        this.handleScroll = () => {
          let path = this.$route.path
          this.isScrolled = this.scrollContainer.scrollTop >= 100
          if (path === '/prize') {
            this.isWhite = this.scrollContainer.scrollTop < 100;
          }
        }
        this.scrollContainer.addEventListener('scroll', this.handleScroll)
        // 初始检查
        this.handleScroll()
      }
    })
  },
  beforeUnmount() {
    // 移除语言切换事件监听
    bus.$off('language-changed', this.onLanguageChanged)
    // 移除滚动监听
    if (this.scrollContainer && this.handleScroll) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    // 语言切换时重新加载分类数据
    onLanguageChanged() {
      this.loadCategories()
    },
    // 加载分类数据
    async loadCategories() {
      try {
        const [productRes, academicRes, newsRes] = await Promise.all([
          getProductCategories(),
          getArticleCategories(1), // 学术资讯
          getArticleCategories(2)  // 企业动态
        ])
        // 处理产品分类
        if (productRes && productRes.code === 200 && productRes.data) {
          this.productCategories = productRes.data.map(item => ({
            id: item.id,
            name: item.name
          }))
        }
        // 处理学术资讯分类
        if (academicRes && academicRes.code === 200 && academicRes.data) {
          this.academicCategories = academicRes.data.map(item => ({
            id: item.id,
            name: item.name
          }))
        }
        // 处理企业动态分类
        if (newsRes && newsRes.code === 200 && newsRes.data) {
          this.newsCategories = newsRes.data.map(item => ({
            id: item.id,
            name: item.name
          }))
        }
      } catch (error) {
        console.error('加载导航分类数据失败:', error)
      }
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible
    },
    // 关闭移动端菜单（保留展开状态）
    closeMobileMenu() {
      this.mobileMenuVisible = false
      // 不清空 expandedMenu，保留上次展开的状态
    },
    // 处理移动端导航点击 - 直接跳转页面
    handleMobileNavClick(item) {
      this.clickTab(item)
      this.closeMobileMenu()
    },
    // 处理移动端二级菜单点击
    handleMobileSubMenuClick(path) {
      this.handleSubMenu(path)
      this.closeMobileMenu()
    },
    // 判断二级菜单是否选中
    isSubMenuActive(path) {
      return this.subMenuPath === path
    },
    clickTab(item) {
      this.tabIndex = item.path
      this.subMenuPath = '' // 点击一级菜单时清空二级菜单选中
      this.$router.push({
        path: item.path,
        query: {}
      })
      // 滚动由全局路由守卫 router.afterEach 统一处理
    },
    //点击有子菜单的导航项
    clickNavWithChildren(item) {
      this.tabIndex = item.path

      // 产品中心点击时默认跳转到第一个二级菜单
      if (item.path === '/products' && item.children && item.children.length > 0) {
        const firstChild = item.children[0]
        this.subMenuPath = firstChild.path
        this.handleSubMenu(firstChild.path)
        return
      }

      // 其他菜单清空二级菜单选中
      this.subMenuPath = ''
      this.$router.push({
        path: item.path,
        query: {}
      })
      // 滚动由全局路由守卫 router.afterEach 统一处理
    },
    //处理子菜单点击
    handleSubMenu(path) {
      this.subMenuPath = path // 更新二级菜单选中状态

      // 解析路径和查询参数
      if (path.includes('?')) {
        const [pathPart, queryString] = path.split('?')
        const query = {}
        queryString.split('&').forEach(param => {
          const [key, value] = param.split('=')
          query[key] = value
        })
        this.$router.push({
          path: pathPart,
          query: query
        })
      } else {
        this.$router.push({
          path: path,
          query: {}
        })
      }

      // 点击子菜单后，手动更新导航状态
      // 滚动由全局路由守卫 router.afterEach 统一处理
      this.$nextTick(() => {
        const pathPart = path.split('?')[0]
        this.dealNav(pathPart)
      })
    },
    //切换语言
    menuClick(langCode) {
      setLanguage(langCode)
    },
    //处理菜单
    dealNav(path) {
      if (this.isMobile) {
        this.isWhite = path === '/prize';
      }
      let arr = path.split("/")
      let mainPath = '/' + arr[1]

      // 获取当前路由的完整路径（含query参数）
      const currentFullPath = this.$route.fullPath

      // 详情页到父级页面的映射关系
      const detailPageMapping = {
        '/productDetail': '/products',  // 产品详情页 -> 产品中心
        '/articleDetail': '/academic',  // 文章详情页 -> 学术资讯
        '/newsDetail': '/news',         // 新闻详情页 -> 企业动态
      }

      // 如果是详情页，映射到对应的父级页面，并清空二级菜单选中
      if (detailPageMapping[mainPath]) {
        mainPath = detailPageMapping[mainPath]
        this.subMenuPath = ''
      }

      // 遍历所有一级菜单
      for (let item of this.navArray) {
        // 检查是否直接匹配一级菜单
        if (item.path === mainPath) {
          this.tabIndex = item.path

          // 检查是否有匹配的二级菜单
          if (item.children && item.children.length > 0) {
            let foundSubMenu = false
            for (let child of item.children) {
              // 比较完整路径（包括查询参数）
              if (child.path === currentFullPath || child.path === path) {
                this.subMenuPath = child.path
                foundSubMenu = true
                break
              }
              // 检查路径和查询参数是否匹配
              const [childPathPart, childQuery] = child.path.split('?')
              if (childPathPart === mainPath && childQuery) {
                const queryParams = {}
                childQuery.split('&').forEach(param => {
                  const [key, value] = param.split('=')
                  queryParams[key] = value
                })
                // 检查当前路由的query是否匹配
                let allMatch = true
                for (let key in queryParams) {
                  if (this.$route.query[key] !== queryParams[key]) {
                    allMatch = false
                    break
                  }
                }
                if (allMatch && Object.keys(queryParams).length > 0) {
                  this.subMenuPath = child.path
                  foundSubMenu = true
                  break
                }
              }
            }
            // 如果没有匹配的二级菜单，清空选中
            if (!foundSubMenu) {
              this.subMenuPath = ''
            }
          }
          return
        }

        // 检查是否匹配子菜单
        if (item.children && item.children.length > 0) {
          for (let child of item.children) {
            // 提取子菜单路径（去掉查询参数）
            let childPath = child.path.split('?')[0]
            // 如果当前路径匹配子菜单路径，激活对应的一级菜单和二级菜单
            if (childPath === path || childPath === mainPath) {
              this.tabIndex = item.path
              this.subMenuPath = child.path
              return
            }
          }
        }
      }

      // 如果都不匹配，清空激活状态
      this.tabIndex = ''
      this.subMenuPath = ''
    },
  },
  watch: {
    // 监听移动端状态变化，切换到PC端时关闭菜单
    isMobile(newVal) {
      if (!newVal) {
        this.mobileMenuVisible = false
        this.expandedMenu = ''
      }
    },
    $route: {
      handler(val, oldVal) {
        let path = val.path
        this.dealNav(path)
      },
      deep: true
    },
  },
}
</script>

<style lang="scss" scoped>
header {
  height: 80px;
  background: #FFFFFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;

  .header-content {
    width: 1000px;
    max-width: 100%;
    box-sizing: border-box;
  }

  .logo-wrapper {
    margin-right: 50px;

    .img-logo {
      width: 97px;
      height: 45px;
      object-fit: scale-down;
    }
  }

  .nav-separator {
    color: #EA8063;
    font-size: 16px;
    user-select: none;
    margin-bottom: 12px;
  }

  .nav-item {
    width: fit-content;
    display: flex;
    position: relative;
    cursor: pointer;
    user-select: none;
    outline: none !important;
    border: none !important;
    font-family: font-m, serif;

    &:active, &:focus, &:focus-visible {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }

    span {
      width: 100%;
      font-size: 16px;
      transition: all 0.3s;
      border-bottom: 2px solid transparent;
      outline: none !important;
    }

    &:hover span {
      color: #EA8063;
    }

    &.nav-item-active span {
      color: #013D5C;
      font-weight: bold;
      border-bottom: 2px solid #EA8063;
    }
  }

  .language-switch {
    display: flex;
    align-items: center;

    .language-btn {
      border: none;
      outline: none;
      margin-bottom: 5px;

      .language-icon {
        width: 18px;
        height: 18px;
        color: #EA8063;
      }

      .language-text {
        color: #013D5C;
        word-break: keep-all;
      }
    }
  }

  // 移动端右侧区域
  .mobile-right {
    display: flex;
    align-items: center;
    margin-left: auto;

    .language-btn {
      border: none;
      outline: none;

      .language-text {
        color: #013D5C;
        word-break: keep-all;
        font-size: 26px;
      }

      .img18 {
        width: 30px;
        height: 30px;
        object-fit: cover;
        margin-right: 10px;
      }

      .img12 {
        object-fit: cover;
        margin-left: 10px;
      }
    }

    .menu-btn {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 30px;

      .menu-icon {
        width: 80px;
        height: 18px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        span {
          display: block;
          width: 30px;
          height: 3px;
          background-color: #e87f62;
          border-radius: 1px;
          transition: all 0.3s ease;
        }

        &.menu-icon-active {
          span:nth-child(1) {
            transform: translateY(8px) rotate(45deg);
          }

          span:nth-child(2) {
            transform: translateY(-8px) rotate(-45deg);
          }
        }
      }
    }
  }

  // 移动端菜单弹出层
  .mobile-menu-overlay {
    position: fixed;
    top: 100px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;

    .mobile-menu-panel {
      background: #FFFFFF;
      max-height: 80vh;
      overflow-y: auto;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      padding: 30px 0;

      .mobile-menu-list {
        padding: 10px 0;

        .mobile-menu-item {
          border-bottom: 1px solid #f0f0f0;

          &:last-child {
            border-bottom: none;
          }

          .mobile-menu-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 20px 20px 100px;
            font-size: 32px;
            color: #454F5E;
            cursor: pointer;
            transition: all 0.3s;

            &:active {
              background-color: rgba(234, 128, 99, 0.1);
            }

            .mobile-menu-arrow {
              font-size: 15px;
              color: #999;
              transition: transform 0.3s;

              &.arrow-rotate {
                transform: rotate(180deg);
              }
            }
          }

          &.mobile-menu-item-active > .mobile-menu-title {
            color: #EA8063;
            font-weight: bold;
          }
        }

        .mobile-sub-menu {
          overflow: hidden;

          .mobile-sub-item {
            padding: 20px 20px 20px 135px;
            font-size: 26px;
            color: #454F5E;
            cursor: pointer;
            transition: all 0.3s;

            &:active {
              background-color: rgba(234, 128, 99, 0.1);
            }

            &.mobile-sub-item-active {
              color: #EA8063;
              font-weight: bold;
              background-color: rgba(234, 128, 99, 0.08);
            }
          }
        }
      }
    }
  }
}

// 移动端样式（通过 isMobile 判断）
header.mobile-mode {
  height: 100px;
  background: transparent !important;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: none !important;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  .header-content {
    width: 100%;
    padding: 0 7% !important;
    justify-content: space-between;
  }

  .logo-wrapper {
    height: 100%;
    margin-right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .img-logo {
      width: auto !important;
      height: 65px;
      object-fit: contain;
    }

    .img-logo-w {
      width: auto !important;
      height: 65px;
      object-fit: contain;
      filter: brightness(0) invert(1);
    }
  }
}

// 手机端滚动超过1000px时显示背景色
header.mobile-mode.header-scrolled {
  background: #FFFFFF !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

// 移动端菜单动画
.mobile-menu-slide-enter-active,
.mobile-menu-slide-leave-active {
  transition: opacity 0.3s ease;

  .mobile-menu-panel {
    transition: transform 0.3s ease;
  }
}

.mobile-menu-slide-enter-from,
.mobile-menu-slide-leave-to {
  opacity: 0;

  .mobile-menu-panel {
    transform: translateY(-20px);
  }
}

// 子菜单展开动画
.sub-menu-expand-enter-active,
.sub-menu-expand-leave-active {
  transition: all 0.3s ease;
  max-height: 300px;
}

.sub-menu-expand-enter-from,
.sub-menu-expand-leave-to {
  opacity: 0;
  max-height: 0;
}

// Element Plus 下拉菜单样式调整
:deep(.el-dropdown) {
  outline: none !important;
  line-height: normal;

  &:focus, &:active, &:focus-visible {
    outline: none !important;
    border: none !important;
  }
}

:deep(.el-dropdown-menu) {
  padding: 10px 0 !important;
  min-width: 220px !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  border-radius: 0 !important;
  background: #FFFFFF !important;
  margin-top: 0 !important;
}

.mobile-menu {
  :deep(.el-dropdown-menu__item) {
    font-size: 25px;
  }
}

:deep(.el-dropdown-menu__item) {
  font-size: 16px;
  color: #013D5C;
  padding: 12px 30px;
  outline: none !important;
  transition: all 0.3s;
  line-height: 1.8;
  text-align: center;
  border: none !important;

  &:hover {
    background-color: rgba(255, 109, 44, 0.05);
    color: #EA8063;
  }

  &:focus, &:active, &:focus-visible {
    outline: none !important;
    background-color: transparent;
    color: #013D5C;
  }

  // 二级菜单选中效果
  &.sub-menu-active {
    background-color: rgba(234, 128, 99, 0.1);
    color: #EA8063;
    font-weight: bold;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 60%;
      background-color: #EA8063;
      border-radius: 0 2px 2px 0;
    }
  }
}
</style>
